import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getElementId } from '../../../../../common/elements/utils/elementPropertyUtils';

// Components
import ToolbarPopup from '../../toolbarPopup/ToolbarPopup';
import ReactionPopupContent from '../../../../components/emoji/popup/ReactionPopup';

// Constants
import { PopupIds } from '../../../../components/popupPanel/popupConstants';
import { TooltipAlignment } from '../../../../components/tooltips/tooltipConstants';

const ReactionPopupContainer = ({ isPopupOpen, selectedElements, ...props }) => {
    const elementIds = selectedElements.map(getElementId).toArray();

    return (
        <ToolbarPopup
            {...props}
            alignment={TooltipAlignment.CENTER}
            popupId={PopupIds.REACTION_TOOL}
            className="ReactionPopup"
        >
            <ReactionPopupContent {...props} closePopup={null} elementIds={elementIds} />
        </ToolbarPopup>
    );
};

ReactionPopupContainer.propTypes = {
    isPopupOpen: PropTypes.bool,
    selectedElements: PropTypes.object,
};

export default ReactionPopupContainer;
